import { OnDemandPublicTrip, RidangoReduxAction } from '@ridango/core';

import { OnDemandTripsActions } from './ondemand-trips.action';


export const ONDEMAND_TRIPS_STATE_KEY = 'onDemandTrips';

export interface OnDemandTripsState {
    trips: OnDemandPublicTrip[];
    polylines: any;
    selected: OnDemandPublicTrip;
    loading: boolean;
}

export const ONDEMAND_TRIPS_INITIAL_STATE: OnDemandTripsState = {
    trips: null,
    polylines: null,
    selected: null,
    loading: false
};

export function onDemandTripsReducer(
    state: OnDemandTripsState = ONDEMAND_TRIPS_INITIAL_STATE,
    action: RidangoReduxAction): OnDemandTripsState {
    switch (action.type) {
        case OnDemandTripsActions.FETCH_ONDEMAND_TRIPS:
            return {
                ...state,
                loading: true
            };
        case OnDemandTripsActions.FETCH_ONDEMAND_TRIPS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false
            };
        case OnDemandTripsActions.FETCH_UPCOMING_TRIPS_SUCCESS:
            return {
                ...state,
                trips: action.payload,
                loading: false
            };
        case OnDemandTripsActions.FETCH_ONDEMAND_TRIPS_FAIL:
            return {
                ...state,
                loading: false
            };
        case OnDemandTripsActions.FETCH_UPCOMING_TRIPS_FAIL:
            return {
                ...state,
                loading: false
            };
        case OnDemandTripsActions.ADD_POLYLINE:
            return {
                ...state,
                polylines: action.payload,
            }
        case OnDemandTripsActions.SET_SELECTED_TRIP:
            return {
                ...state,
                selected: action.payload,
            }
    }

    return state;
}
